/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsRepeatV: {
  name: 'arrows-repeat-v';
  data: string;
} = {
  name: 'arrows-repeat-v',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.707 2.293a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L17 5.414V20h-4a1 1 0 1 0 0 2h4a2 2 0 0 0 2-2V5.414l1.293 1.293a1 1 0 1 0 1.414-1.414l-3-3ZM7 2a2 2 0 0 0-2 2v14.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L7 18.586V4h4a1 1 0 1 0 0-2H7Z" fill="currentColor"/></svg>`,
};
